export function isValidThemeColor(theme = {}, color = null) {
  if (theme.length === 0 || !color) {
    return false;
  }

  if (typeof color !== 'string') {
    throw new Error('Theme color must be a string');
  }

  if (theme.length === 0) {
    throw new Error('Theme object must be provided');
  }

  // TODO: Check for hex color value and compare against theme palette values.
  if (!theme.palette?.[color]) {
    throw new Error(`Theme color "${color}" is not defined in palette`);
  }

  return true;
}

export function getThemeColor(theme = {}, color = '', contrastColor = '') {
  let themeColor = color && isValidThemeColor(theme, color)
    ? theme.palette[color].main
    : theme.palette.focus90.main;

  if (contrastColor) {
    themeColor = theme.palette.getContrastText(theme.palette[contrastColor].main);
  }

  return themeColor;
}
